import React, { useRef } from "react";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { TimePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
// import Select from "react-dropdown-select";
import dayjs from 'dayjs';

import Select from "react-select";

import "../../../../../../StyleSheet/MainComponent/UDSEMployee/Reimbursementemp.scss";
import fileUpload from "../../../../../../Assets/MainComponent/fileUpload.svg";
import { setTheCreateOfEmployeeReimbursementActions } from "../../../../../../Redux/Slice"
import { store } from "../../../../../../Redux/Store"
import { toast } from "react-toastify";
import ImageCropper from "../../../../ReactcropOverall/Imagecrop";
import Button from "@mui/material/Button";
import { PresentUrl } from "../../../../../../text/apidata";
import axios from "axios";
import PlusIcon from "../../../../../../Assets/AppComponent/Asset 9.svg"
import minus from "../../../../../../Assets/AppComponent/Asset 10.svg"
import {
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { NumericFormat } from "react-number-format";


const ReimbursementPopup = (props) => {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    selectedPerformanceId,
    setEditPayload,
    GetFilter
  } = props;
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const leaveTypes = useSelector((state) => state.LeaveTypeData.LeaveTypeData);
  const [imgsrc, setImgsrc] = useState();
  const [forindex, setforindex] = useState();

  const [selectedLeave, setSelectedLeave] = useState("");

  const [data, setData] = useState({
    purpose: "",
    request_type: "request",
    user_id: "",
    reason_type: "",
    from_place: "",
    to_place: "",
    date: "",
    way_type: "",
    for_date: "",
    Kilometer: "",
    wheeler_type: "",
    amount: "",

  });
  const [fieldErrors, setFieldErrors] = useState({
    for_date: "",
    purpose: "",
    from_time: "",
    to_time: "",
  });
  const [ReimbursementTypeerrr, setreimbursementErr] = useState("");
  const [Kilometererr, setKilometererr] = useState("");
  const [Amounterro, setAmounterr] = useState("");
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);

  const fileInputRef = useRef()
  ///--stay
  const [DateErr, setDateErr] = useState("");
  const [LocationErr, setLocationErr] = useState("");
  const [PurposeErr, setPurposeErr] = useState("");
  ///amount
  /// travel 
  const [FromErr, setFromerr] = useState("");
  const [ToError, setToError] = useState("");
  ///amount , date 
  ///foood 
  ///amount ,date 
  const updateAvatar = (imgSrc) => {
    fileInputRef.current = imgSrc;
  };
  const [ErrorIndex, setErrInde] = useState(0)
  const currentYear = dayjs().year();
  const startOfYear = dayjs().startOf('year');
  const endOfYear = dayjs().endOf('year');
  

  const leaveTypeOptions = leaveTypes.map((item) => ({
    value: item.id,
    label: item.leave_type,
  }));
  leaveTypeOptions.unshift({
    value: "",
    label: "Select type of leave",
    isDisabled: true,
  });

  const [value, setValue] = useState("one");
  const [fuelValue, setFuelValue] = useState("four");
  const reasonFeeder = [
    {
      value: "fuel",
      label: "Fuel",
    },
    {
      value: "stay",
      label: "Stay",
    },
    {
      value: "travel",
      label: "Travel",
    },
    {
      value: "food",
      label: "Food",
    },
  ];
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleFuleValueChange = (event) => {
    setFuelValue(event.target.value);
  };
  const [images, setImages] = useState([]);
  const [number, setNumber] = useState(1);
  const [keyName, setKeyName] = useState("document1");

  const [imageFiles, setImageFiles] = useState();
  const [documentPassed, setdocumentPassed] = useState(false)
  const [imagesFile, setImagesFile] = useState([]);

  const [imagesPost, setImagesPost] = useState([]);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //     };
  //     reader.readAsDataURL(file);
  //     setNumber((prevNumber) => prevNumber + 1);
  //     setImageFiles(e);

  //     setCroppImageView(true)

  //     const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
  //     const maxSize = 10 * 1024 * 1024; // 10MB in bytes
  //     const MIN_DIMENSION = 150;

  //     if (file && allowedTypes.includes(file.type)) {
  //       if (file.size > maxSize) {
  //         setCroppImageView(false);
  //         toast.error("File size exceeds 10MB. Please upload a smaller image.");
  //       } else {
  //         const reader = new FileReader();
  //         reader.addEventListener("load", () => {
  //           const imageElement = new Image();
  //           const imageUrl = reader.result?.toString() || "";
  //           imageElement.src = imageUrl;

  //           imageElement.addEventListener("load", (imgEvent) => {
  //             const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

  //             if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
  //               toast.error("Image must be at least 150 x 150 pixels.");
  //               setCroppImageView(false);
  //               return;
  //             }
  //             // s/electedImage(file,);
  //           });
  //         });
  //         reader.readAsDataURL(file); // Read the file as a data URL
  //       }
  //     } else {
  //       setCroppImageView(false);
  //       toast.error("Please upload an image file (jpg, jpeg, png, svg).");
  //     }

  //   }
  // };

  const [inputFields, setInputFields] = useState([
    {
      Files: "",
      file: "",
    },
  ]);
  const [PresentUrls, setPresentUrls] = useState([])
  const [updated, setupdatefile] = useState(false);



  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = "";
      return newImages;
    });
    setInputFields(values);
    const updatedImagesFile = [...imagesFile];

    updatedImagesFile[forindex] = "";
    setImagesFile(updatedImagesFile);
  };
  const handleAddFields = (index) => {
    if (inputFields.length != 10) {

      const values = [...inputFields];
      values.push({
        Files: "",
        file: "",
      });

      setInputFields(values);
      setImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index] = "";
        return newImages;
      });
    }
  };


  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedImagesPost = imagesPost.filter((_, i) => i !== index);
    setImages(updatedImages);
    setImagesPost(updatedImagesPost);
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleDate = (inputDate, name) => {

    const value = formatDate(inputDate);
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];

    if (event.target.name === "file") {
      setImageFiles(event)
      //console.log(event.target.files[0], "evefasfsdl");
      setCroppImageViewCount(index);
      setCroppImageView(true);
      setupdatefile(true);



      const file = event.target.files[0];
      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      const MIN_DIMENSION = 150;

      if (file && allowedTypes.includes(file.type)) {
        if (file.size > maxSize) {
          setCroppImageView(false);
          toast.error("File size exceeds 10MB. Please upload a smaller image.");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (imgEvent) => {
              const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

              if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                toast.error("Image must be at least 150 x 150 pixels.");
                setCroppImageView(false);
                return;
              }
            });
          });
          reader.readAsDataURL(file); // Read the file as a data URL
        }
      } else {
        setCroppImageView(false);
        toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      }
    }

    setInputFields(values);
  };

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );


    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        var file = croppedFile;
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false)

          }, 0);
        }
        const valuesFile = [...inputFields]; ///file
        console.log(valuesFile, "asdpaspod oiasud valuesFile");

        valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
        setInputFields(valuesFile);

        const generateRandomNumber = () => {
          return Math.floor(Math.random() * 100000);
        };

        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/re_certificate/re_certificate${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        const Presentdata = createPresentData(croppedFile);

        setupdatefile(true);

        axios({
          url: PresentUrl,
          method: 'post',
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " +
              store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
          },
        })
          .then((response) => {
            console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data;

            const newUrls = uploadedFiles.map(file => ({
              url: file,
              type: croppedFile.type,
              putfiles: croppedFile

            }));
            setPresentUrls(prevUrls => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = newUrls[0];
              return updatedUrls;
            });



            const updatedImageUrl = String(response.data.data).split("?")[0]
            const values = [...inputFields]; ///----result
            values[forindex].certificate = String(response.data.data).split("?")[0];
            setInputFields(values);

            setImagesFile(prevUrls => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = String(response.data.data).split("?")[0];
              return updatedUrls;
            });

          }).catch((error) => {
            console.error('Error uploading files:', error);
          });

        setdocumentPassed(true);



        var fileBase = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });
          const values = [...inputFields];
          values[forindex].Files = reader.result;
          setInputFields(values);
          setImages((prevImages) => [...prevImages, reader.result]);
          setImagesPost((prevImagesPost) => [
            ...prevImagesPost,
            { key: `document${number}`, file: croppedFile },
          ]);


          console.log(inputFields, "inputFields");
        };
        reader.readAsDataURL(fileBase);
        //  }

        blob.name = fileName;
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }
  const handleClose = () => {
    setEditPayload("");
    setShow(false);
    setData({
      for_date: "",
      purpose: "",
      request_type: "request",
      from_time: "",
      to_time: "",
      user_id: "",
      place_id: "",
    });
    setFieldErrors({
      for_date: "",
      purpose: "",
      from_time: "",
      to_time: "",
    });
    setSelectedLeave("");
  };

  const handleSubmit = () => {

    var a = 0;
    if (data.reason_type == "") {
      setreimbursementErr("*Please select reason")
      a = 1;
    }

    if (data.reason_type != "" && data.amount == "") {
      a = 1;
      setAmounterr("*Amount is requried")
    }
    if (data.reason_type != "" && data.for_date == "") {
      a = 1;
      setDateErr("*Date is requried")
    }
    if (selectedLeave != "") {
      if (selectedLeave == "fuel") {
        if (data.Kilometer == "") {
          a = 1;
          setKilometererr("*Kilometer is requried")
        }
      }
      if (selectedLeave == "travel") {
        if (data.from_place == "") {
          setFromerr("*Place is requried");
          a = 1;
        }
        if (data.to_place == "") {
          setToError("*Place is requried")
          a = 1;
        }
      }
      if (selectedLeave == "stay") {
        if (data.purpose == "") {
          setPurposeErr("*Purpose is requried");
          a = 1;
        }
        if (data.from_place == "") {
          setFromerr("*Place is requried");
          a = 1;
        }
      }
    }

    if (a == 0 && ErrorIndex == 0) {
      const fetchUploadFiles = async () => {
        await Promise.all(PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {

              const response = await fetch(item.url, {
                method: 'PUT',
                headers: {
                  'Content-Type': item.type,
                  "x-amz-acl": "public-read"
                },
                body: item.putfiles,
              });

              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }

              if (PresentUrls.length == index + 1) {

                let formdatas = selectedLeave == "fuel" ?
                  {
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                      .id,
                    reason_type: data.reason_type,
                    Kilometer: data.Kilometer,
                    for_date: data.for_date,
                    amount: data.amount,
                    wheeler_type: fuelValue,
                    documents: []
                  } : selectedLeave == "stay" ? {
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                      .id,
                    reason_type: data.reason_type,
                    for_date: data.for_date,
                    amount: data.amount,
                    purpose: data.purpose,
                    //location
                    documents: [],
                    from_place: data.from_place

                  } : selectedLeave == "travel" ? {
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                      .id,
                    reason_type: data.reason_type,
                    for_date: data.for_date,
                    amount: data.amount,
                    way_type: value,
                    from_place: data.from_place,
                    to_place: data.to_place,
                    documents: []

                  } : selectedLeave == "food" && {
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                      .id,
                    reason_type: data.reason_type,
                    for_date: data.for_date,
                    amount: data.amount,
                    documents: []
                  }

                imagesFile.forEach((element, index) => {
                  if(element != null && element != undefined && element !=""){ 
                  formdatas.documents.push(element)
                  }
                });


                const payload = {
                  formdatas: formdatas,
                  API: 1,
                  GetFilter: GetFilter

                }
                console.log(formdatas, "sadasd formdatas");

                dispatch(setTheCreateOfEmployeeReimbursementActions(payload))
                setShow(false)
                setPresentUrls([]);


              }

            }
          } catch (error) {
            console.error('Error uploading files:', error);
          }
        }));
      };

      if (documentPassed == true && a == 0 && ErrorIndex == 0) {
        fetchUploadFiles()

      }

      else if (documentPassed == false && a == 0 && ErrorIndex == 0) {

        const payload = {
          formdatas: selectedLeave == "fuel" ?
            {
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              reason_type: data.reason_type,
              Kilometer: data.Kilometer,
              for_date: data.for_date,
              amount: data.amount,
              wheeler_type: fuelValue,
              documents: [],
            } : selectedLeave == "stay" ? {
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              reason_type: data.reason_type,
              for_date: data.for_date,
              amount: data.amount,
              purpose: data.purpose,
              //location
              from_place: data.from_place,
              documents: [],

            } : selectedLeave == "travel" ? {
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              reason_type: data.reason_type,
              for_date: data.for_date,
              amount: data.amount,
              way_type: value,
              from_place: data.from_place,
              to_place: data.to_place,
              documents: [],

            } : selectedLeave == "food" && {
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              reason_type: data.reason_type,
              for_date: data.for_date,
              amount: data.amount,
              documents: [],
            },
          GetFilter: GetFilter
        }


        dispatch(setTheCreateOfEmployeeReimbursementActions(payload))
        setShow(false)

      }

    }
  };
   console.log(fuelValue ,"fuelValue");
   

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="leaveApplyWrapper ">
          <div className="leaveApplyWrapperRows">
            <h3>Reimbursement Request</h3>
            {/* <div className="CloseIcon" onClick={handleClose}>
              <CloseOutlinedIcon />
            </div> */}
          </div>

          <div className="row customInput customInputRem" style={{ height: "100%", display: "flex" }}>
            <div className="col-sm-2">
              <label htmlFor="leaveDate">
                Reason<span style={{ color: "red" }}>*</span>
              </label>
              <Select
                // className="basic-single"
                 className="Select"
                // classNamePrefix="select"
                placeholder="Select a reimbursement type"
                isSearchable={true}
                // id="leaveType"
                options={reasonFeeder}
                onChange={(e) => {
                  setData((prev) => ({
                    ...prev,
                    reason_type: e.value,
                  }));
                  setSelectedLeave(e.value);
                  setreimbursementErr("");
                }}
                style={{ zIndex: "999" }}
              />
              <p className="Error">{ReimbursementTypeerrr}</p>

            </div>

            {selectedLeave.length > 0 && (
              <>
                {/* <div className="row customInput customInputRem"> */}
                {selectedLeave === "travel" && (
                  <>               <div className="col-sm-2">
                    <label htmlFor="leaveDate">
                      Way
                    </label>
                    <div style={{ display: "flex", flexDirection: "row", width: "281px" }}>
                      <RadioGroup
                        aria-label="trip-type"
                        name="trip-type"
                        value={value}
                        onChange={handleChange}
                        className="col-12 radio"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <FormControlLabel
                          value="one"
                          control={<Radio />}
                          label="One way"
                          checked={value === "one"}
                        />
                        <FormControlLabel
                          value="round"
                          control={<Radio />}
                          label="Round trip"
                          checked={value === "round"}
                        />
                      </RadioGroup>

                    </div>

                  </div>

                    <div className="col-sm-2 ">
                      <label htmlFor="leaveDate ">
                        From<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="formDatas"
                        type="text"
                        value={data.from_place}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            from_place: e.target.value,
                          }));
                          setFromerr("");
                        }}
                      />
                      <p className="Error">{FromErr}</p>
                    </div>



                    <div className="col-sm-2">

                      <label htmlFor="leaveDate">
                        To<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="formDatas"

                        value={data.to_place}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            to_place: e.target.value,
                          }));
                          setToError("");
                        }}
                      />
                      <p className="Error">{ToError}</p>
                    </div>
                  </>
                )}

                {selectedLeave === "fuel" && (
                  <>
                    <div className="col-sm-2">
                      <label htmlFor="leaveDate">
                        Way
                      </label>
                      <div style={{ display: "flex", flexDirection: "row", width: "325px", marginLeft:"-32px" }}>

                        <RadioGroup
                          aria-label="trip-type"
                          name="trip-type"
                          value={fuelValue}
                          onChange={handleFuleValueChange}
                          className="col-12 radio"
                          style={{ display: "flex", flexDirection: "row" }}

                        >
                          <FormControlLabel
                            value="two"
                            control={<Radio />}
                            label="Two Wheeler"
                            checked={fuelValue === "two"}
                          />
                          <FormControlLabel
                            value="four"
                            control={<Radio />}
                            label="Four Wheeler"
                            checked={fuelValue === "four"}
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    <div className="col-sm-2 SixAdjust" style={{marginLeft:"54px"}}>
                      <label htmlFor="leaveDate">
                        Kilometer<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="formDatas"
                        type="text"
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            Kilometer: e.target.value,
                          }));
                          setKilometererr("");
                        }}
                      />
                      <p className="Error">{Kilometererr}</p>
                    </div>
                  </>
                )}

                {selectedLeave === "stay" && (
                  <>

                    <div className="col-sm-2 SixAdjust" style={{ marginLeft: "12px" }}>

                      <label htmlFor="leaveDate">
                        Location<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="formDatas"
                        type="text"
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            from_place: e.value,
                          }));
                          setFromerr("");
                        }}
                      />
                      <p className="Error">{FromErr}</p>
                    </div>
                    <div className="col-sm-2 SixAdjust" style={{ marginLeft: "12px" }}>
                      <label htmlFor="leaveDate">
                        Purpose<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="formDatas"
                        type="text"
                        value={data.purpose}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            purpose: e.target.value,
                          }));
                          setPurposeErr("");
                        }}
                      />
                      <p className="Error">{PurposeErr}</p>
                    </div>

                  </>
                )}


                {/* </div> */}
              </>
            )}

            {selectedLeave.length > 0 && (
              <>
                <div className="col-sm-2 SixAdjust DateFiletsEMp" style={{ marginLeft: "10px", marginRight: "12px" }}>

                  <label htmlFor="leaveDate">
                    Date<span style={{ color: "red" }}>*</span>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    style={{ width: "100%" }}
    onChange={(e) => {
      handleDate(e?.$d, "for_date");
      setDateErr("");
    }}
    minDate={startOfYear}
    maxDate={endOfYear}
  />
</LocalizationProvider>

                  <p className="Error">{DateErr}</p>
                </div>


                <div className="col-sm-2 SixAdjust" style={{ marginLeft: "10px", marginRight: "12px" }}>

                  <label htmlFor="leaveDate">
                    Amount<span style={{ color: "red" }}>*</span>
                  </label>

                  <NumericFormat
                    thousandSeparator={true}
                    onValueChange={(values) => {
                      const { value } = values;

                      // Parse the value as a number
                      const parsedValue = parseFloat(value);

                      // Check if input exceeds 8 digits
                      if (value.length > 8) {
                        setAmounterr("*Amount cannot exceed 8 digits.");
                        setErrInde(1);
                        // Revert to previous valid value
                        setData((prev) => ({
                          ...prev,
                          amount: data.amount,
                        }));
                        return;
                      }

                      if (parsedValue <= 0) {
                        setAmounterr("*Amount Salary must be greater than 0.");
                        setErrInde(1);
                        // Clear the field
                        setData((prev) => ({
                          ...prev,
                          amount: "",
                        }));
                        return;
                      }

                      // Valid input
                      setAmounterr("");
                      setErrInde(0);
                      setData({
                        ...data,
                        gross_salary: value
                      });
                      setData((prev) => ({
                        ...prev,
                        amount: value,
                      }));
                    }}

                    autocomplete="off"
                    name="gross_salary"
                    value={data.gross_salary}
                    isNumericString
                    displayType={"input"}
                    fixedDecimalScale={true}
                    className="form-control FormalFiledReport"

                  />

                  <p className="Error">{Amounterro}</p>
                </div>

                <div className="col-sm-12 Documentfiled">
                  <div style={{ display: "flex" }}>

                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "100%" }}
                    >
                      Documents
                    </label>
                  </div>

                  <div style={{ display: "flex" }}>
                    {inputFields.map((inputField, index) => {
                      return (
                        <Fragment key={`${inputField}~${index}`}>
                          <div
                            className="form-group "
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              className=" btn  StatusList"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                gap: "20px",
                              }}
                            >

                              <div
                                className="col-sm-7"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                  flexDirection: "column",
                                }}
                              >
                                {inputField.Files &&
                                  <img
                                    // src={images[0]}
                                    src={inputField.Files}
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      border: "1px solid #000",
                                      borderRadius: "10px",
                                    }}
                                  />
                                }

                                <Button
                                  className="doctorupload"
                                  variant="contained"
                                  component="label"
                                  style={{
                                    background: "#234492", color: "#fff",
                                    fontSize: "11px !important"
                                  }}
                                >

                                  <input
                                    type="file"
                                    hidden
                                    accept="image/png, image/jpeg"
                                    name="file"
                                    // onChange={(e) => handleFiles(e)}
                                    onChange={(event) => {
                                      setforindex(index);
                                      handleInputChange(index, event);
                                    }}
                                    ref={fileInputRef}

                                  />
                                  Upload Image
                                </Button>
                              </div>

                              <div className="col" style={{ display: "flex", gap: "19px" }}>

                                <>
                                  <button
                                    className="DeclineStatus"
                                    disabled={index === 0}
                                    onClick={() => {
                                      handleRemoveFields(index);
                                    }}
                                  >
                                    <span>
                                      <img src={minus} />
                                    </span>
                                  </button>
                                  {index === 0 ?
                                    // <div
                                    //   className="AddingButton"
                                    //   onClick={(index) => {
                                    //     if(index +1 != 5)
                                    //     handleAddFields(index);
                                    //   }}
                                    //   style={{
                                    //     backgroundColor: "#F58837",
                                    //     fontSize: "19px",
                                    //     width: "  20px",
                                    //     height: "20px ",
                                    //     borderRadius: "50%",
                                    //     display: "flex",
                                    //     alignItems: "center",
                                    //     justifyContent: "center",
                                    //   }}
                                    // >
                                    //   <span className="PlusButton">
                                    //     <img src={PlusIcon} />
                                    //   </span>
                                    // </div>
                                    <div
                                      className="AddingButton"
                                      onClick={() => {
                                        if (inputFields.length < 5) {
                                          handleAddFields();
                                        }
                                      }}
                                      style={{
                                        backgroundColor: "#F58837",
                                        fontSize: "19px",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: inputFields.length >= 5 ? "not-allowed" : "pointer",
                                      }}
                                    >
                                      <span className="PlusButton">
                                        <img src={PlusIcon} alt="Add" />
                                      </span>
                                    </div>

                                    : null}

                                </>

                              </div>


                            </div>
                          </div>


                        </Fragment>
                      );
                    })}
                  </div>
                </div>
              </>
            )}

          </div>


          <div className="ReimbursementButttonEmp" style={{ marginBottom: "30px" }}>


            <button class="btn CancelBtn" onClick={handleClose}>
              Cancel
            </button>
            <button
              class="btn "
              type="submit"
              onClick={(e) => {
                handleSubmit();
              }}
            >
              Submit
            </button>
          </div>
        </div>

      </div>
      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={imageFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default ReimbursementPopup;
